"use client"

import React, { ReactElement, ReactNode } from "react"
import styled, { useTheme } from "styled-components"
import FormControlLabel from "@mui/material/FormControlLabel"
import MUCheckbox from "@mui/material/Checkbox"
import { BaseStyles } from "@jobintrans/base-ui.types.base-styles"
import { Box } from "@jobintrans/base-ui.components.atoms._atoms"

const TextCheckbox = ({
  name,
  error,
  children,
  value,
  rhf,
  onClick,
  ...rest
}: BaseStyles & {
  name: string
  value?: boolean
  error?: {
    type?: string
    message?: string
  }
  children: ReactNode | ReactElement | ReactElement[] | string
  rhf?: object & { ref?: React.Ref<any> }
  onClick?: () => void
}) => {
  const theme = useTheme()

  return (
    <Wrapper {...rest}>
      <FormControlLabel
        onClick={onClick}
        control={
          <MUCheckbox
            {...rhf}
            name={name}
            checked={value}
            sx={{
              "color": error ? theme?.color?.red : theme?.color?.second,
              "&.Mui-checked": {
                color: theme?.color?.primary,
              },
              "& .MuiSvgIcon-root": { fontSize: 20 },
            }}
          />
        }
        label={children}
      />
    </Wrapper>
  )
}

export default TextCheckbox

const Wrapper = styled(Box)`
  * {
    box-sizing: border-box;
  }

  .MuiFormControlLabel-root {
    margin-left: 0 !important;
    margin-right: 0 !important;
    align-items: flex-start;
  }

  .MuiCheckbox-root {
    padding: 0 !important;
    margin-right: 10px;
  }

  .MuiTypography-root {
    font-size: ${({ theme }) => theme.font.S};
    color: ${({ theme }) => theme.color.secondary};
    font-weight: ${({ theme }) => theme.font.light};

    a,
    span {
      color: ${({ theme }) => theme.color.primary};
    }
  }
`
